import Icon from '../../../components/AppIcon';

const PerformanceMetrics = ({ metrics }) => {
  const metricCards = [
    {
      label: 'Comments Posted',
      value: metrics?.commentsPosted,
      change: metrics?.commentsPostedChange,
      icon: 'MessageSquare',
      color: 'text-primary bg-primary/10'
    },
    {
      label: 'Profile Visits',
      value: metrics?.profileVisits,
      change: metrics?.profileVisitsChange,
      icon: 'Eye',
      color: 'text-accent bg-accent/10'
    },
    {
      label: 'New Followers',
      value: metrics?.newFollowers,
      change: metrics?.newFollowersChange,
      icon: 'UserPlus',
      color: 'text-success bg-success/10'
    },
    {
      label: 'Response Rate',
      value: `${metrics?.responseRate}%`,
      change: metrics?.responseRateChange,
      icon: 'TrendingUp',
      color: 'text-warning bg-warning/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {metricCards?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4 hover:shadow-card transition-all duration-150">
          <div className="flex items-start justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${metric?.color}`}>
              <Icon name={metric?.icon} size={20} />
            </div>
            {metric?.change !== undefined && (
              <div className={`flex items-center gap-1 px-2 py-1 rounded text-xs font-medium ${metric?.change >= 0 ? 'bg-success/10 text-success' : 'bg-error/10 text-error'}`}>
                <Icon name={metric?.change >= 0 ? 'TrendingUp' : 'TrendingDown'} size={12} />
                <span>{Math.abs(metric?.change)}%</span>
              </div>
            )}
          </div>
          <p className="text-2xl font-bold text-foreground mb-1">{metric?.value}</p>
          <p className="text-sm text-muted-foreground">{metric?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default PerformanceMetrics;